import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import { format as dateFnsFormat } from 'date-fns';
/**
 * 时间字符串或时间戳转换为日期对象
 * @param date 时间字符串或unix时间戳
 * @returns Date对象
 */

export function toDate(date) {
  if (typeof date === 'number') {
    return new Date(date * 1000);
  }

  return new Date(date.replace(/-/g, '/'));
}
/**
 * 格式化日期成字符串
 * 利用date-fns库里的format函数来格式化 @see {@link https://date-fns.org/v2.8.1/docs/format}
 * @param date 日期对象或字符串或unix时间戳
 * @param format 转化格式
 * @example
 * format(new Date(2019, 11, 31)) // 2020-12-31 00:00:00
 * @return 格式化后的字符串
 */

export function format(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Y-MM-dd HH:mm:ss';

  if (!(date instanceof Date)) {
    date = toDate(date);
  }

  return dateFnsFormat(date, format);
}